export const SETDEFAULTASSIGNEELIST = "SETDEFAULTASSIGNEELIST";
export const SETPROJECTLEADLIST = "SETPROJECTLEADLIST";
export const SETPROJECTTYPELIST = "SETPROJECTTYPELIST";
export const SETPROJECTSTATUSLIST = "SETPROJECTSTATUSLIST";
export const SETUSERLIST = "SETUSERLIST";
export const CLEARDOC = "CLEARDOC";
export const SETPROJECTLIST = "SETPROJECTLIST";
export const SETPROJECTDETAIL = "SETPROJECTDETAIL";
export const SETPROJECTFILTERLIST = "SETPROJECTFILTERLIST";
export const SETNEWPROJECTDETAILS = "SETNEWPROJECTDETAILS";
export const SETPROJECTSBASICFILTERDATA = "SETPROJECTSBASICFILTERDATA";

